export default function Categories() {
  return (
    <div>
      <h2>The Categories section is currently Under Construction</h2>
      <h2>Stay Tuned!</h2>
    </div>
  );
}
